import styled from 'styled-components';

export const MemberPoolStorageStyle = styled.div`
  .generated-list__table-wrapper {
    min-height: 740px;
  }
  .rt-table .rt-tbody .rt-tr-group {
    &:nth-child(
      ${({ selectedRowIndex }) => {
  if (typeof selectedRowIndex !== 'number') {
    return -1;
  }
  return selectedRowIndex + 3;
}}
    ) > .rt-tr {
      background-color: #dbffdb;
    }
  }
`;
